// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__14-pV","heading":"style_heading__3QEr1","bg":"style_bg__1zuop","bgone":"style_bgone__3gaW7"};